import React from 'react';
import PropTypes from 'prop-types';
import { Box, Divider } from '@mui/material';

function DrawerFooter({ children, divider = false, sx }) {
	return (
		<Box
			sx={{
				mt: 'auto',
				pt: 0,
				pb: 3,
				px: 3,
				backgroundColor: 'background.paper',
				flexShrink: 0,
				...sx,
			}}
		>
			{divider && <Divider sx={{ mt: 2, mb: 2 }} />}
			{children}
		</Box>
	);
}

DrawerFooter.propTypes = {
	children: PropTypes.node,
	divider: PropTypes.bool,
	sx: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
};

export default React.memo(DrawerFooter);
